<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t(
            'administration.mobile_feature.notification.template_setup.template_setup'
          )
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.notification.template_setup.template_setup'
            ),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'notification-template-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="
                $t(
                  'administration.mobile_feature.notification.template_setup.search'
                )
              "
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ $store.getters.limitStringShow(record.not_subject) }}</td>
          <td>{{ record.notification_type.not_type }}</td>
          <td class="text-center">
            <a
              href="#"
              class="mr-2 text-primary"
              v-tooltip="$t('edit')"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'notification-template',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('notificationTemplate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.notificationTemplate.search
      },
      set(newValue) {
        this.$store.commit('notificationTemplate/SET_SEARCH', newValue)
        this.$store.commit('notificationTemplate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t(
            'administration.mobile_feature.notification.template_setup.subject'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.template_setup.notification_type'
          ),
          style: 'width: 30%;'
        },
        {
          name: this.$t(
            'administration.mobile_feature.notification.template_setup.actions'
          ),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('notificationTemplate/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    edit(record) {
      let { ...resource } = record
      this.$store.commit('notificationTemplate/SET_EDIT_DATA', resource)
      this.$router.push({
        name: 'notification-template-edit',
        params: { id: record.not_template_id }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'notification-template-create') {
      this.$store.commit('notificationTemplate/RESET_STATE')
    }
    next()
  }
}
</script>
